import { loadStripe, type Appearance } from "@stripe/stripe-js";

const PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;

/** Null when the publishable key isn't configured (payments then show a notice instead). */
export const stripePromise =
  PUBLISHABLE_KEY && !PUBLISHABLE_KEY.includes("replace_me") ? loadStripe(PUBLISHABLE_KEY) : null;

/** The brand's theme tokens (brands/<id>/theme.css), for Stripe's form, which can't read CSS variables. */
const token = (name: string, fallback: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;

/** Stripe Elements styled like the site: the brand's colors and font. */
export const appearance = (): Appearance => ({
  theme: "stripe",
  variables: {
    colorPrimary: token("--primary", "#333333"),
    colorText: token("--heading", "#222222"),
    colorDanger: token("--stripe", "#ca3232"),
    fontFamily: token("--font", "Helvetica, Arial, sans-serif"),
    borderRadius: token("--radius", "3px"),
  },
});
